import React,{useState} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: "black",
    fontWeight:"bold"
  },
}));

export default function Projects() {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>

      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>1.</Typography>
          <Typography className={classes.secondaryHeading}>
            Peronal Project
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
              <p style={
                { fontWeight:"bolder",
                  color:"blue",
                  fontSize:"1rem",
                  marginTop:"-1.5rem",
                  marginLeft:"2rem"
                }
              }>
               Windoshoppe
            </p>
             <p> Business network help students sell and Buy items among themselves <br/> Provides high capacity of users compared to WhatsApp groups hence students can interact with no limit</p>
             <a href="https://tmuc-open-market.netlify.app">Link: windoshoppe.netlify.app</a> work in peogress...

          </div>
        </AccordionDetails>
        <br/>
        <AccordionDetails>
          <div>
              <p style={
                { fontWeight:"bolder",
                  color:"blue",
                  fontSize:"1rem",
                  marginTop:"-1.5rem",
                  marginLeft:"2rem"
                }
              }>
               Tom Mboya Student
            </p>
             <p> A Progressive web application created with ReactJs, NodeJs , GraphQl and Apollo <br/> Helps students at Tom Mboya University acces school onlines resouces esily through an installable web application and ability to communicate through a virtucal noticeboard.</p>
             <a href="https://tmuc.netlify.app"> Link: TMUC STUDENT</a>

          </div>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>2.</Typography>
          <Typography className={classes.secondaryHeading}>
            More...
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>

            <ol>
              <p>NextJs Blog <a href="https://businessacademy.netlify.app"> - Business academy</a></p>
              <br/>
              <p><a href="https://tmuc.netlify.app">TMUC Web App - </a> A web application to help Tom Mboya Student navigate through school website easily instead of relying on google searches.</p>
              <br/>
              <p> <a href="https://the-argument.netlify.app">The argument</a> Progressive Web App to help footbal fans exchange messages defending the teams they surport in an open forum</p>
            </ol>

          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
